/**
 *
 * #### Use it with null-coaelsing operator
 * For example:
 * ```
 *    getInsidedData()?.device
 *    getInsidedData()?.user.userid
 * ```
 */
export const getInsidedData = (): InsidedData | null => {
  if (typeof window === 'undefined') {
    return null
  }
  return window.inSidedData ?? null
}
